import { render, staticRenderFns } from "./tab-form.vue?vue&type=template&id=2cf26398&"
import script from "./tab-form.vue?vue&type=script&lang=js&"
export * from "./tab-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports